import { render, staticRenderFns } from "./rich_viewer.vue?vue&type=template&id=5fc47aa8&vue3"
import script from "./rich_viewer.vue?vue&type=script&lang=js&vue3"
export * from "./rich_viewer.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports